import React from 'react';

const ToolTip = ({text, children, style={}, ...props}) => {
  return <span data-tip={text} {...props} style={{cursor: 'pointer', position: 'absolute', ...style}}>
    {children}
  </span>
}

export default ToolTip